import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const DemoApi = {

	get(modelId) {

		return new Promise(function (resolve) {
			// A mock async action using setTimeout
			setTimeout(function () {
				resolve({
					data: {
						item: {
							id: modelId,
							title: "The Demo Model"
						},
						validationResults: {},
						beadModels: [
							{
								"tab": 0,
								"volledig": 1,
								"titel": "Organisator"
							},
							{
								"tab": 1,
								"volledig": 0,
								"titel": "Veldtoertocht"
							},
							{
								"tab": 2,
								"volledig": 1,
								"titel": "Lussen1"
							},
							{
								"tab": 2,
								"volledig": 0,
								"titel": "Lussen2"
							}]
					}
				});
			}, 3000);
		});

		// const serviceUrl = prependRoot('/demo/' + id, getApiRoot());
		// return axios.get(serviceUrl, {
		// 	headers: {
		// 		'accept': 'application/json'
		// 	}
		// });
	},
	getEmpty() {

		return new Promise(function (resolve) {
			// A mock async action using setTimeout
			setTimeout(function () {
				resolve({
					data: {
						item: {
							id: "emptyModelId",
							title: "The empty Model"
						},
						validationResults: {}
					}
				});
			}, 3000);
		});
		// const serviceUrl = prependRoot('/demo/empty/', getApiRoot());
		// return axios.get(serviceUrl, {
		// 	headers: {
		// 		'accept': 'application/json'
		// 	}
		// });
	},
	save(model, documents) {
		const serviceUrl = prependRoot('/demo', getApiRoot());
		return axios.put(serviceUrl, {
			item: model,
			documenten: documents
		},
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default DemoApi;